var __jsx = React.createElement;
import React from "react";
var ActionButton = function ActionButton(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "outline" : _ref$variant,
    id = _ref.id;
  var baseClasses = "w-[90%] md:w-1/2 md:mx-auto mb-2 p-4 rounded-lg text-center cursor-pointer text-[16px] font-semibold absolute mx-auto bottom-2 left-0 right-0";
  var variantClasses = variant === "primary" ? "bg-primary-new text-white" : "text-primary-new border-[1px] border-solid border-primary-new";
  return /*#__PURE__*/React.createElement("div", {
    id: id || "action-button-".concat(variant),
    className: "".concat(baseClasses, " ").concat(variantClasses),
    onClick: onClick
  }, children);
};
export default ActionButton;